module.exports = __webpack_public_path__ + "img/sprinkle-12.89a5300a.webp";